// extracted by mini-css-extract-plugin
export default {"root":"CheckboxWithText_root__BMCAs"};